// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"f0b8c9e7","162":"dc807f23","242":"a9d94556","369":"fd6e9c15","393":"3d74a0e8","532":"30d46552","722":"32505e1d","787":"450f1ef8","984":"5427b506"}[chunkId] + ".chunk.js";
};